<template>
  <v-app>
    <toolbar @navigationDrawerClicked="$refs.navigation_drawer.toggleDrawer()"/>
    <navigation-drawer ref="navigation_drawer"/>

    <v-content>
      <router-view class="router-view"/>
    </v-content>

    <v-footer class="justify-center mt-6">
      <v-btn text href="mailto:info@eldritchtracker.com">Contact us</v-btn>
      <v-btn @click="$router.push({name: 'change-log'})" text>v0.6</v-btn>
<!--      <v-btn text @click="$router.push({name: 'rules'})">Rules</v-btn>-->
<!--      <v-btn text @click="$router.push({name: 'gdpr'})">GDPR</v-btn>-->
    </v-footer>
  </v-app>
</template>

<script>
  import Toolbar from "./components/layout/Toolbar";
  import NavigationDrawer from "./components/layout/NavigationDrawer";

  export default {
    name: "App",

    components: {
      Toolbar,
      NavigationDrawer
    },

    watch: {
      '$route' (to) {
        document.title = (to.meta.title || 'Your Website') + " | Eldritch Tracker";
      }
    }
  };
</script>
